import React from 'react';
import config from '../../config';
import { HTMLTrans } from './Translations';
import FreeShippingTierInfoModal from './FreeShippingTierInfoModal';

export const FreeShippingTierBadge = ({ lang, t }) => {
    const imageUrl = `${config.s3BucketUrl}/assets/general/fst_truck.svg`;

    return (
        <div>
            <div className='row col ml-0 mb-4 free-shipping-tier-badge__description'>
                <img className='mr-1 free-shipping-tier-badge__image' src={imageUrl} />
                <HTMLTrans id='footer.common_freeshippingtierbadge'>
                    <p>Eligible for FREE shipping. <a href='#' className='free-shipping-tier-badge__anchor' data-toggle='modal' data-target='#free-shipping-tier-info-modal'>Learn more</a></p>
                </HTMLTrans>
            </div>
            <FreeShippingTierInfoModal lang={lang} t={t} />
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/Common/FreeShippingTierBadge.js